import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';

import Popup from '../../Popup';
import { PopupBodyWrapper, Button } from './styles';

interface SynchronizationLogoutPopupProps {
	isDisplayed: boolean;
	onDeferLogout: () => void;
	onCancel: () => void;
}

const SynchronizationLogoutPopup = ({
	isDisplayed,
	onDeferLogout,
	onCancel,
}: SynchronizationLogoutPopupProps) => (
	<Popup
		isDisplayed={isDisplayed}
		label={I18n.t('messages.updating_content_structure')}
		onCancel={onCancel}
	>
		<PopupBodyWrapper>
			<Button
				type="button"
				onClick={onDeferLogout}
			>
				<Translate value="messages.logout_once_sync_finished" />
			</Button>
		</PopupBodyWrapper>
	</Popup>
);

export default SynchronizationLogoutPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/SynchronizationLogoutPopup/index.tsx